module.exports = __webpack_public_path__ + "img/cuestionario-resultado.4909687b.svg";